import LiveKitPrimaryButton from '../../../components/LiveKitPrimaryButton';

import { Flex, Icon, Text } from '@amigoapp/doca-react';

const LiveKitConnectionLost = ({ isDuplicate, isReconnecting, onReconnect }) => (
	<Flex align="center" className="lk-call" direction="col" flex={1} justify="center">
		<Flex align="center" className="doctor-stage-message" direction="col" gap={3} justify="center">
			<Icon name="wifi-slash" type="light" />
			<Text align="center" weight="bold">
				{isDuplicate ? 'Você entrou na consulta em outro aparelho' : 'Sua conexão com a consulta caiu'}
			</Text>
			<Text align="center" size="small" weight="light">
				{isDuplicate
					? 'Para continuar a consulta por aqui, toque no botão abaixo.'
					: 'A consulta continua em andamento. Toque no botão abaixo para voltar.'}
			</Text>
			<LiveKitPrimaryButton loading={isReconnecting} onClick={onReconnect}>
				{isDuplicate ? 'Continuar por aqui' : 'Reconectar'}
			</LiveKitPrimaryButton>
		</Flex>
	</Flex>
);

export default LiveKitConnectionLost;
